import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import { CreatePhotoRequest } from '@/../gen';

export const namespace = 'photo';
const actionCreator = actionCreatorFactory(namespace);

export const CreatePhoto = actionCreator<CreatePhotoRequest>('CREATE_PHOTO');

export interface State {}

const initialState = (): State => {
  return {};
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(CreatePhoto, async function(_context, action) {
      const { data } = await this.proffApi.createPhoto(action.payload.image);
      // @ts-ignore FIXME
      return data.data.attributes.image.url;
    })
  ),
};
